// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__shGnH","title":"Card_title__3Va6-","year":"Card_year__W02mv","user":"Card_user__nMhvC","toolbar":"Card_toolbar__2od4E","button":"Card_button__2t1dK"};